import React from 'react';

const slugifySubdomain = (name) =>
  (name || '').toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/--+/g, '-')
    .slice(0, 128) || 'onboarding';

const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5" style={{ flexShrink: 0 }}>
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

const ReviewStep = ({ formData, hrAssignees = [] }) => {
  const {
    name, description, hr_assigned_user_id, step_flags,
    welcome, forms, documents, subdomain,
  } = formData;

  const sf = step_flags || { welcome: true, forms: true, documents: true };
  const selectedForms = forms?.selectedForms || [];
  const selectedDocs = documents?.selectedDocuments || [];

  const hrAssignee = hrAssignees.find(hr => String(hr.id) === String(hr_assigned_user_id));
  const hrName = hrAssignee
    ? `${hrAssignee.name}${hrAssignee.email ? ` (${hrAssignee.email})` : ''}`
    : '';

  const portalUrl = (subdomain || slugifySubdomain(name)) + '.gappeo.hr';

  return (
    <div>
      <div className="ob-hint ob-hint--success" style={{ marginBottom: 20 }}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
        </svg>
        All steps configured. Finish as draft to save, or Publish to make it active.
      </div>

      <div style={{ background: '#fff', border: '1px solid #e4e9f0', borderRadius: 12, padding: 22 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: '#1a1a2e', marginBottom: 20 }}>Flow summary</div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 32 }}>

          {/* Left: flow details */}
          <div>
            <div style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 11, color: '#9aa3b0', marginBottom: 3 }}>Flow name</div>
              <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a2e' }}>{name || '—'}</div>
            </div>

            {description && (
              <div style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 11, color: '#9aa3b0', marginBottom: 3 }}>Description</div>
                <div style={{ fontSize: 13, color: '#525b66', lineHeight: 1.5 }}>{description}</div>
              </div>
            )}

            <div style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 11, color: '#9aa3b0', marginBottom: 3 }}>HR assignment</div>
              <div style={{ fontSize: 13, fontWeight: 500, color: '#1a1a2e' }}>{hrName || '—'}</div>
            </div>
            
          </div>

          {/* Right: portal steps */}
          <div>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a2e', marginBottom: 14 }}>
              Candidate onboarding steps
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {sf.welcome && (
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13 }}>
                  <CheckIcon />
                  <span style={{ color: '#1a1a2e', lineHeight: 1.4 }}>
                    Welcome screen
                    {welcome?.title && (
                      <span style={{ color: '#8a9199' }}> — {welcome.title}</span>
                    )}
                  </span>
                </div>
              )}
              {sf.forms && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
                  <CheckIcon />
                  <span style={{ color: '#1a1a2e' }}>
                    Custom forms ({selectedForms.length} attached)
                  </span>
                </div>
              )}
              {sf.documents && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
                  <CheckIcon />
                  <span style={{ color: '#1a1a2e' }}>
                    Company documents ({selectedDocs.length} attached)
                  </span>
                </div>
              )}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ReviewStep;
